'use strict';

/**
 * Wasabi Regions
 *
 * As of 11th May 2022, these were provided by Wasabi based on where their FGW servers have been deployed.
 */
module.exports = {
    /** Tokyo */
    apNortheast1: 'ap-northeast-1',
    /** Tokyo */
    apNortheast2: 'ap-northeast-2',
    /** Singapore */
    apSoutheast1: 'ap-southeast-1',
    /** Sydney */
    apSoutheast2: 'ap-southeast-2',

    /** Dallas */
    usCentral1: 'us-central-1',
    /** New Jersey */
    usEast1: 'us-east-1',
    /** New Jersey */
    usEast2: 'us-east-2',
    /** Seattle */
    usWest1: 'us-west-1',

    /** Toronto */
    caCentral1: 'ca-central-1',

    /** Amsterdam */
    euCentral1: 'eu-central-1',
    /** Amsterdam */
    euCentral2: 'eu-central-2',
    /** London */
    euWest1: 'eu-west-1',
    /** Paris */
    euWest2: 'eu-west-2'
};